import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ManageRoleService {
  baseURL = environment.API_BASE_PATH;

  constructor(private commonService: CommonService,
    readonly userInfoService: UserInfoService) { }

  getRoleList(groupName) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + `/tenant/role/list/group/${groupName}`, headers);
  }

  createRole(val: any) {
    let headers = { headers: { 'Accept-Version': 'V1', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.postCall(environment.API_BASE_PATH + '/tenant/roles', val, headers);
  }

  deleteRole(roleName) {
    let headers = { headers: { 'Accept-Version': 'V1', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.deleteCall(environment.API_BASE_PATH + `/tenant/role/${roleName}`, headers);
  }

  editRole(val, roleName) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.putCall(environment.API_BASE_PATH + `/tenant/role/${roleName}`, val, headers);
  }

  getRolesByUserId(userId) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + `/tenant/role/user/${userId}`, headers);
  }
}
